import { Box, Typography, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";

const TradeShowCTA = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        // mt: { sx: -8, md: -8 },
        // px: 2,
      }}
    >
      <Box
        sx={{
          backdropFilter: "blur(10px)",
          //   backgroundColor: "rgba(255,255,255,0.65)",
          backgroundColor: "rgb(216, 216, 216)",
          display: "flex",
          flexDirection: "row",
          gap: 2,
          borderRadius: "12px",
          padding: { xs: 2, md: 2 },
          //   maxWidth: "650px",
          textAlign: "center",
          boxShadow: "0 8px 24px rgba(17, 15, 15, 0.15)",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            // mb: 1,
          }}
        >
          Ready to connect with us at the show?
        </Typography>

        {/* <Typography
          variant="body1"
          sx={{
            color: "#333",
            // mb: 1,
          }}
        >
          Tell us about your business and we'll get you set up.
        </Typography> */}

        <Link
          component="button"
          underline="hover"
          onClick={() => navigate("/clientRegistration")}
          sx={{
            fontWeight: "bold",
            fontSize: "16px",
            color: "#0B5D2A",
            cursor: "pointer",
          }}
        >
          Count Me In →
        </Link>
      </Box>
    </Box>
  );
};

export default TradeShowCTA;
